import { findLastKey } from "lodash-es";
import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";

import { Description } from "./description/description";
import { DocumentList } from "./documentList/documentList";
import { FeatureList } from "./featureList/featureList";
import { hasDocuments } from "./helpers";
import { Navigation } from "./navigation/navigation";
import { Review } from "./review/review";

type ProductInfoProps = {
    product: FullProductApiModel;
    maxVisibleFeatures: number;
    reviewsEnabled: boolean;
};

const ProductInfo = ({
    product,
    maxVisibleFeatures,
    reviewsEnabled,
}: ProductInfoProps) => {
    const { t } = useGranite();

    const hasDocumentResult = hasDocuments(product);

    return (
        <>
            <span id="specs" className="anchor-span"></span>
            <h2 className="title my-2 anchor-sm-hide">
                <span
                    className="title__content"
                    data-test="titleComponent-Productinformatie"
                >
                    {t("productDetail.title.productInfo")}
                </span>
            </h2>

            <Navigation product={product} reviewsEnabled={reviewsEnabled} />

            <div className="pb-4 pb-sm-0">
                <Description product={product} />
                <FeatureList
                    product={product}
                    maxVisibleFeatures={maxVisibleFeatures}
                />
                {reviewsEnabled && <Review product={product} />}
                {hasDocumentResult && <DocumentList product={product} />}
            </div>
        </>
    );
};

export { ProductInfo };
